<template>
  <div>
    <el-row>
      <h2>User Logout</h2>
    </el-row>
    <el-row>
      <div>
        Email:
        <el-input v-model="form.email" style="width: 260px;"></el-input>
      </div>
    </el-row>
    <el-row style="margin-top: 8px;">
      <div>
        Code:
        <el-input v-model="form.code" style="width: 160px;"></el-input>
        <el-button @click="getCode()" :disabled="isCount" style="width: 96px;">{{isCount?'('+count+')':'Get code'}}</el-button>
      </div>
    </el-row>

    <el-row style="margin-top: 8px;">
      <el-button @click="userLogout()" :disabled="form.code.length<4">Logout</el-button>
    </el-row>
  </div>


</template>

<script>
  import {Message, MessageBox} from 'element-ui'

  export default {
    name: 'Index',
    data() {
      return {
        count: 0,
        isCount: false,
        msg: '',
        packageName: "",
        form: {
          email: "",
          code: ""
        },
        timer: ""
      }
    },

    mounted() {
      this.packageName = this.$route.params.packageName
    },

    onLoad(options) {

    },
    methods: {
      getCode() {
        console.log("getCode", this.count);
        var _this = this;
        if (this.count > 0) {
          return
        }
        this.count = 60;
        this.getRequest(`/user/captcha?email=${this.form.email}&packageName=${this.packageName}`).then(res => {
          console.log(res);
          if (res.data && res.data.ret == 0) {
            _this.isCount = true;
            _this.startCount();
          } else {
            _this.count = 0;
            Message.error({message: 'get code fail', center: true});

          }
        }).catch(e => {
          _this.count = 0;
          Message.error({message: 'get code fail', center: true});
          console.log(e);
        })
      },
      startCount() {
        this.timer = setInterval(this.timeCount, 1000)
      },
      timeCount() {
        this.count--;
        if (this.count <= 0) {
          clearInterval(this.timer);
          this.isCount = false;
        }
      },
      userLogout() {
        var _this = this;
        if (this.form.code.length < 4) {
          Message.error({message: 'please enter code', center: true});
          return
        }
        this.$confirm('Confirm logout?', 'Warning').then((e) => {
          _this.form.packageName = _this.packageName;
          _this.postRequest("user/email/logout", _this.form)
            .then(res => {
              console.log(res);
              if (res.data && res.data.ret == 0) {
                Message.success({message: 'Logout success', center: true});
              } else {
                Message.error({message: res.data.message || 'Logout fail', center: true});
              }
            }).catch(e => {
            Message.error({message: 'Logout fail', center: true});
          })
        }).catch(() => {

        });

      }
    }
  }
</script>

<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue